import { getFullUrl } from 'hubspot-url-utils';
import { useTranslation } from '../../../hooks/useNavConfig';
import { AccountExtraLink } from './AccountExtrasLink';
import { jsx as _jsx } from "react/jsx-runtime";
export const AccountsAndBillingLink = ({
  isDevPortal,
  portalId
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(AccountExtraLink, {
    id: "accountsAndBilling",
    link: isDevPortal ? `${getFullUrl('app')}/developer/${portalId}/account/` : `${getFullUrl('app')}/account-dashboard/${portalId}/`,
    linkText: isDevPortal ? t('nav.tools.devAccount') : t('nav.tools.billing'),
    spaceAbove: isDevPortal
  });
};